module.exports = __webpack_public_path__ + "static/img/SHIFTING EFFECT PU products discription3_deskstop.dc251265.jpg";